import { useState, useEffect, useRef, RefObject } from "react";

interface Dimensions {
  top: number;
  left: number;
  width: number;
  height: number;
  scrollWidth: number;
  clientWidth: number;
}

const useComponentDimensions = (
  elementRef: RefObject<HTMLElement> | null
): Dimensions => {
  const [dimensions, setDimensions] = useState<Dimensions>({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    scrollWidth: 0,
    clientWidth: 0
  });

  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    if (!elementRef || !elementRef.current) {
      return;
    }

    const handleResize = (entries: ResizeObserverEntry[]): void => {
      if (entries && entries.length > 0) {
        const { top, left, width, height } =
          entries[0].target.getBoundingClientRect();
        const { scrollWidth, clientWidth } = entries[0].target;
        setDimensions({ top, left, width, height, scrollWidth, clientWidth });
      }
    };

    resizeObserverRef.current = new ResizeObserver(handleResize);
    resizeObserverRef.current.observe(elementRef.current);

    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, [elementRef]);

  return dimensions;
};

export default useComponentDimensions;
